module.exports = __webpack_public_path__ + "img/icon_map_38_off_011.da7bbc05.png";